import {KTSVG} from '../../../../_metronic/helpers'
import {MDBCard, MDBCardBody, MDBCardText, MDBCardTitle, MDBCol, MDBRow} from 'mdb-react-ui-kit'
import {Link} from 'react-router-dom'
import "./FuturesCard.css"

const FuturesCard = () => {
  return (
    <div className='row gy-1 g-xl-8 card'>
      <div style={{display: 'flex', justifyContent: 'flex-end' ,alignItems: 'center', marginTop: 5}} className="card-header w-full flex justify-start ">
        <h1 className="card-title text-lg font-bold flex items-center">
          فرصت های سرمایه گذاری
          <KTSVG path='/media/icons/duotune/general/gen024.svg' className='svg-icon-2 m-2' />
        </h1>
      </div>

      <div dir={'rtl'} style={{ marginTop: 2 }} className={'card-body cursor-pointer w-100 w-full flex justify-end items-center'}>
          <MDBRow className={'w-full'}>
            <MDBCol lg={'3'}>
              <Link to={'/stock/sales'}>
                <MDBCard className={'p-4 cursor-pointer investCard '}>
                  <MDBCardBody className={'text-center'}>
                    <MDBCardText>
                      سهام عمومی
                    </MDBCardText>
                  </MDBCardBody>
                </MDBCard>
              </Link>
            </MDBCol>
            <MDBCol lg={'3'}>
              <Link to={'/stock/sales'}>
              <MDBCard className={' p-4 cursor-pointer investCard  '}>
                <MDBCardBody className={'text-center'}>
                  <MDBCardText>
                       سهام ICU
                  </MDBCardText>
                </MDBCardBody>
              </MDBCard>
              </Link>
            </MDBCol>
            <MDBCol lg={'3'}>
              <Link to={'/stock/sales'}>
              <MDBCard className={'p-4 cursor-pointer investCard'}>
                <MDBCardBody className={'text-center'}>
                  <MDBCardText>
                    سهام درمانگاه
                  </MDBCardText>
                </MDBCardBody>
              </MDBCard>
              </Link>
            </MDBCol>
            <MDBCol lg={'3'}>
              <Link to={'/stock/sales÷'}>
              <MDBCard className={'p-4 cursor-pointer investCard'}>
                <MDBCardBody className={'text-center'}>
                  <MDBCardText>
                     سهام داندانپزشکی
                  </MDBCardText>
                </MDBCardBody>
              </MDBCard>
              </Link>
            </MDBCol>
          </MDBRow>
       </div>


      <div style={{display: 'flex', justifyContent: 'flex-end' ,alignItems: 'center', marginTop: 5}} className="card-header w-full flex justify-start ">
        <h1 className="card-title text-lg font-bold flex items-center">
          خدمات
          <KTSVG path='/media/icons/duotune/general/gen024.svg' className='svg-icon-2 m-2' />
        </h1>
      </div>
        <div dir={'rtl'} style={{ marginTop: 2 }} className={'card-body cursor-pointer w-100 w-full flex justify-end items-center'}>
          <MDBRow className={'w-full'}>
            <MDBCol lg={'3'}>
              <MDBCard className={'bg-light p-4 cursor-pointer hover:bg-gray-200 box-hover-shadow'}>
                <MDBCardBody className={'text-center'}>
                <Link to ='/stock/transfer'>
                  <MDBCardText>
                      انتقال سهام
                  </MDBCardText>
                  </Link>
                </MDBCardBody>
              </MDBCard>
            </MDBCol>
            <MDBCol lg={'3'}>
              <MDBCard className={'bg-light p-4 cursor-pointer hover:bg-gray-200 box-hover-shadow'}>
                <MDBCardBody className={'text-center'}>
                  <MDBCardText>
                      خدمات بیمه
                  </MDBCardText>
                </MDBCardBody>
              </MDBCard>
            </MDBCol>
            <MDBCol lg={'3'}>
              <MDBCard className={'bg-light p-4 cursor-pointer hover:bg-gray-200 box-hover-shadow'}>
                <MDBCardBody className={'text-center'}>
                  <MDBCardText>
                    ثبت درخواست جدید
                  </MDBCardText>
                </MDBCardBody>
              </MDBCard>
            </MDBCol>
            <MDBCol lg={'3'}>
              <MDBCard className={'bg-light p-4 cursor-pointer hover:bg-gray-200 box-hover-shadow'}>
                <MDBCardBody className={'text-center'}>
                  <MDBCardText>
                    سوالات متداول
                  </MDBCardText>
                </MDBCardBody>
              </MDBCard>
            </MDBCol>
          </MDBRow>
        </div>
    </div>
  )
}

export default FuturesCard
